import { assignIfExists } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';

const changeLayout = (from, to) => {
  const turnOffFocus = from === to && to === 'focus';
  return turnOffFocus ? '' : to;
};

const updateFullScreen = withDraft((draft) => { draft.fullscreen = !draft.fullscreen; });

const updateShowLabels = withDraft((draft) => { draft.labels = !draft.labels; });

const updateLayout = withDraft((draft, { layout }) => {
  draft.oldLayout = draft.layout;
  draft.layout = changeLayout(draft.layout, layout);
});

const toggleRibbon = withDraft((draft) => { draft.ribbonIsVisible = !draft.ribbonIsVisible; });

const updateActions = withDraft((draft, action) => { assignIfExists(draft.actions, action); });

const updateTabs = withDraft((draft, { tabs }) => { draft.tabs = tabs; });

const updateTitle = withDraft((draft, { title }) => { draft.title = title; });

export default {
  [actions.TOGGLE_RIBBON]: toggleRibbon,
  [actions.UPDATE_ACTIONS]: updateActions,
  [actions.UPDATE_FULL_SCREEN]: updateFullScreen,
  [actions.UPDATE_LAYOUT]: updateLayout,
  [actions.UPDATE_SHOW_LABELS]: updateShowLabels,
  [actions.UPDATE_TABS]: updateTabs,
  [actions.UPDATE_TITLE]: updateTitle,
};
